import React from 'react'

export const drugAllergies: string[] = [
    'Penicillin',
    'Aspirin',
    'Ibuprofen',
    'Sulfa drugs',
    'Tetracycline',
    'Codeine',
    'Cephalosporins',
    'Anticonvulsants',
    'Chemotherapy drugs',
    'NSAIDs',
    'Amoxicillin',
    'Cephalexin',
    'Ceftriaxone',
    'Sulfamethoxazole',
    'Acetaminophen',
    'Morphine',
    'Hydrocodone',
    'Oxycodone',
    'Rivaroxaban',
    'Warfarin',
    'Metformin',
    'Lisinopril',
    'Ciprofloxacin',
    'Clindamycin',
    'Other (Please specify)'
];

